import HttpServiceBase from "../httpServiceBase";
import { ISearchResults } from "@myinnsworth/models/ISearchResults";
import INewsArticle from "@myinnsworth/models/news/INewsArticle";
import ISearchNewsModel from "./models/ISearchNewsModel";

class NewsHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'news' };

    public async search(model: ISearchNewsModel): Promise<ISearchResults<INewsArticle>> {
        if(model.caseSlug) {
            model.extra = {
                caseSlug: model.caseSlug
            };
        }
        return await this.typedGet<ISearchResults<INewsArticle>>(this.buildSearchUrl(`search`, model));
    }

    public async fetch(id: number, caseSlug?: string): Promise<INewsArticle> {
        const endpoint = caseSlug ? `${caseSlug}/${id}` : `${id}`;
        return await this.typedGet<INewsArticle>(endpoint);
    }
}

const service = new NewsHttpService();
export default service;